import * as React from 'react'

const Wheel4 = props => {
  const gradientColors = (
    <>
      <stop stopColor="#482A0F" />
      <stop offset="0.1" stopColor="#A37129" />
      <stop offset="0.15" stopColor="white" />
      <stop offset="0.22" stopColor="#D69A41" />
      <stop offset="0.34" stopColor="#8B5924" />
      <stop offset="0.5" stopColor="#D4A24D" />
      <stop offset="0.66" stopColor="#F1E07D" />
      <stop offset="0.72" stopColor="#D6BD65" />
      <stop offset="0.77" stopColor="white" />
      <stop offset="0.83" stopColor="#9B752B" />
      <stop offset="1" stopColor="#66421A" />
    </>
  )
  return (
    <svg
      viewBox="0 0 112 112"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M55.8586 108.651C85.4987 108.651 109.527 84.6227 109.527 54.9826C109.527 25.3425 85.4987 1.31445 55.8586 1.31445C26.2185 1.31445 2.19043 25.3425 2.19043 54.9826C2.19043 84.6227 26.2185 108.651 55.8586 108.651Z"
          fill="url(#paint0_linear_7794_19157)"
        />
        <path
          d="M55.8588 107.063C84.6243 107.063 107.943 83.7444 107.943 54.9789C107.943 26.2135 84.6243 2.89453 55.8588 2.89453C27.0934 2.89453 3.77441 26.2135 3.77441 54.9789C3.77441 83.7444 27.0934 107.063 55.8588 107.063Z"
          fill="url(#paint1_radial_7794_19157)"
        />
        <path
          d="M73.675 103.925L38.0459 6.03906"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M64.9037 106.275L46.8164 3.68945"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M55.8584 107.063V2.89453"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M46.8164 106.275L64.9037 3.68945"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M38.0459 103.925L73.675 6.03906"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M29.8174 100.088L81.9018 9.875"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M22.3809 94.879L89.339 15.082"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M15.96 88.4621L95.7569 21.5039"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M10.7539 81.0219L100.967 28.9375"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M6.91602 72.7929L104.802 37.166"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M4.56738 64.025L107.152 45.9355"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M3.77441 54.9824H107.943"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M4.56738 45.9355L107.152 64.025"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M6.91602 37.166L104.802 72.7929"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M10.7539 28.9375L100.967 81.0219"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M15.96 21.5039L95.7569 88.4621"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M22.3809 15.082L89.339 94.879"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M29.8174 9.875L81.9018 100.088"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M38.0459 6.03906L73.675 103.925"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M46.8164 3.68945L64.9037 106.275"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M55.8584 2.89453V107.063"
          stroke="#D9BA7C"
          strokeWidth="0.729449"
          strokeMiterlimit="10"
        />
        <path
          d="M55.859 99.7043C80.5595 99.7043 100.583 79.6806 100.583 54.9801C100.583 30.2796 80.5595 10.2559 55.859 10.2559C31.1585 10.2559 11.1348 30.2796 11.1348 54.9801C11.1348 79.6806 31.1585 99.7043 55.859 99.7043Z"
          fill="url(#paint2_linear_7794_19157)"
        />
        <path
          d="M55.8582 99.0855C80.2163 99.0855 99.9625 79.3394 99.9625 54.9812C99.9625 30.6231 80.2163 10.877 55.8582 10.877C31.5001 10.877 11.7539 30.6231 11.7539 54.9812C11.7539 79.3394 31.5001 99.0855 55.8582 99.0855Z"
          fill="url(#paint3_linear_7794_19157)"
        />
        <path
          d="M55.859 96.2024C78.6238 96.2024 97.0784 77.7478 97.0784 54.983C97.0784 32.2182 78.6238 13.7637 55.859 13.7637C33.0942 13.7637 14.6396 32.2182 14.6396 54.983C14.6396 77.7478 33.0942 96.2024 55.859 96.2024Z"
          fill="url(#paint4_linear_7794_19157)"
        />
        <path
          d="M55.8585 95.5802C78.2821 95.5802 96.4601 77.4022 96.4601 54.9786C96.4601 32.5549 78.2821 14.377 55.8585 14.377C33.4348 14.377 15.2568 32.5549 15.2568 54.9786C15.2568 77.4022 33.4348 95.5802 55.8585 95.5802Z"
          fill="url(#paint5_radial_7794_19157)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.8451 14.377C33.4906 14.377 15.2588 32.6088 15.2588 54.9632C53.0565 17.321 97.8026 75.0724 96.4314 54.9632C96.4314 32.6088 78.1995 14.377 55.8451 14.377Z"
          fill="url(#paint6_linear_7794_19157)"
        />
        <path
          d="M78.0769 38.6562H61.523L60.7454 39.5456L55.8583 45.1424L50.9712 39.5456L50.1935 38.6562H33.6396L37.4052 42.9694L47.8957 54.9845L37.4052 66.9996L33.6396 71.3106H50.1935L50.9712 70.4212L55.8583 64.8244L60.7454 70.4212L61.523 71.3106H78.0769L74.3114 66.9996L63.8209 54.9845L74.3114 42.9694L78.0769 38.6562ZM72.353 41.2586L60.3686 54.9845L72.353 68.7104H62.7059L55.8605 60.8683L49.015 68.7104H39.3679L51.3523 54.9845L39.3679 41.2586H49.015L55.8605 49.1007L62.7059 41.2586H72.353Z"
          fill="#00D5D4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7794_19157"
          x="-0.000108242"
          y="0.000130296"
          width="111.717"
          height="111.717"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.876215" />
          <feGaussianBlur stdDeviation="1.09527" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7794_19157"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7794_19157"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7794_19157"
          x1="100.267"
          y1="1.51598"
          x2="12.3436"
          y2="89.4376"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <radialGradient
          id="paint1_radial_7794_19157"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.24 45.5399) scale(52.0844 52.0844)">
          <stop offset="0.05" stopColor="#383E45" />
          <stop offset="1" stopColor="#1E272E" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_7794_19157"
          x1="92.9294"
          y1="8.85172"
          x2="19.6603"
          y2="82.1208"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <linearGradient
          id="paint3_linear_7794_19157"
          x1="56.2394"
          y1="89.6465"
          x2="56.2394"
          y2="1.43574"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F0C362" />
          <stop offset="0.28" stopColor="#A47E2C" />
          <stop offset="0.36" stopColor="#230B0A" />
          <stop offset="0.46" stopColor="#6D4C1E" />
          <stop offset="0.51" stopColor="#1A0B05" />
          <stop offset="0.53" stopColor="#F4EEDA" />
          <stop offset="0.86" stopColor="#EFDFBD" />
          <stop offset="1" stopColor="#CCA75B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7794_19157"
          x1="85.1158"
          y1="16.6683"
          x2="27.3623"
          y2="74.4197"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <radialGradient
          id="paint5_radial_7794_19157"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(56.2396 45.5395) scale(40.6016 40.6016)">
          <stop offset="0.05" stopColor="#383E45" />
          <stop offset="1" stopColor="#1E272E" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_7794_19157"
          x1="15.2566"
          y1="36.8628"
          x2="96.4598"
          y2="36.8628"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.01" stopColor="#606060" />
          <stop offset="0.03" stopColor="#5D5D5D" />
          <stop offset="0.21" stopColor="#3B3B3C" />
          <stop offset="0.4" stopColor="#212122" />
          <stop offset="0.59" stopColor="#0E0E10" />
          <stop offset="0.79" stopColor="#030305" />
          <stop offset="1" stopColor="#000002" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Wheel4
